import React from 'react'
import { updateOrderPayload } from '../../../actions'
import { Formik, Field } from 'formik';
import { RaisedButton } from 'material-ui';

const statusList = [{
  name: '',
  key: 7,
}, {
  name: 'Customer Review',
  key: 4
}, {
  name: 'CR - Not Printed',
  key: 3
}, {
  name: 'CR - Contacted',
  key: 2
}, {
  name: 'CR - Resolved',
  key: 1
}, {
  name: 'Reprint',
  key: 5
}, {
  name: 'Refunds/Upcharges',
  key: 6
}]

class Status extends React.Component {
  constructor(props) {
    super(props)
  }

  renderAlert() {
    const statusAlert = this.props && this.props.order && this.props.order.alert && this.props.order.alert.replace(/['"]+/g, '')
    if (alert !== null || alert !== '') {
      return (
        <div style={{marginBottom:'20px'}}>
          <span style={{float: 'left'}}>Current Processing Status:</span>
          <span style={{ marginLeft: '10px', color: 'red' }}>{statusAlert}</span>
        </div>
      );
    }
  }
  render() {
    const { order, dispatch, disableView } = this.props
    const initialValues = {
      alert: order.alert || ''
    }
    var hideView = disableView ? 'hidden' : 'visible'
    return (
      <div style={{ paddingLeft:'40px', paddingBottom: '20px' }}>
        {this.renderAlert()}
        <div style={{visibility: hideView}}>
          <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
              //console.log("STATUS", values)
              dispatch(updateOrderPayload(order.id, 'alert', values.alert))
            }}
            render={(props) => (
              <form onSubmit={props.handleSubmit}>
                <Field
                  name='alert'
                  component='select'>
                  <option disabled selected>
                    Select Status
                  </option>
                  {statusList.map((option) =>
                    <option
                      key={option.key}
                      value={option.name}
                      selected={option.name ? true : false}
                    >
                      {option.name}
                    </option>
                  )}
                </Field>
                <RaisedButton style={{marginLeft: '10px'}} type='submit' primary>Save</RaisedButton>
              </form>
            )}
          />
        </div>
      </div>
    )
  }
}
export default Status


// WEBPACK FOOTER //
// ./src/components/orders/Common/Status.js